<template>
    <div>
        <div class="ui-datepicker-inline" ref="datepicker"></div>
        <div role="button" tabindex="0" @click="changeDateToNextWinter" class="link-small text-end px-3" v-if="isShowNextSeasonButton">
            {{nextWinterContent}}
            <ArrowRight />
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import 'jquery-ui/ui/widgets/datepicker'
import {getStartOfWinterDate} from "../logic/getStartOfWinterDate"
import ArrowRight from "./svg/common/arrow-right/index.vue"
import {winterStartMonth} from "../config/defaults"
import isWinterSeason from '../utils/isWinterSeason.ts'

export default {
    name: 'Datepicker',
    components: {
        ArrowRight
    },
    props: {
        value: Date,
        getDefaultDate: Function,
        getAvailableDates: Function,
        month: String,
        showOtherMonths: Boolean,
        contents: Object,
        store: Object,
        showNextSeasonButton: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            data: {
                obj: null,
                availableDates: {},
                currentCalendarYear: null,
                currentCalendarMonth: null
            },
            off: {},
            state: {}
        }
    },
    computed: {
        nextWinterContent() {
            const currentYear= new Date().getFullYear()
            const nextYear = currentYear + 1
            return `${this.contents.winter} ${currentYear}-${nextYear}`
        },
        
		/**
		 * Determines whether the "Next Season" button should be displayed.
		 *
		 * This method checks if the current month on the calendar is not equal to
		 * the `winterStartMonth` and also not within the winter season. If both
		 * conditions are met, it returns the value of `this.showNextSeasonButton`; 
		 * otherwise, it returns `false`.
		 *
		 * The winter season is determined by the `isWinterSeason` function, which
		 * uses the current month and year to check if it's winter.
		 *
		 * @returns {boolean} - Returns `true` if the "Next Season" button should be 
		 * displayed, otherwise returns `false`.
		 */
         isShowNextSeasonButton() {
            return this.data.currentCalendarMonth != winterStartMonth && !isWinterSeason(this.data.currentCalendarMonth, this.data.currentCalendarYear) ? this.showNextSeasonButton : false
        },
    },
    methods: {
        init: function (options) {
            var self = this
            this.data.obj.datepicker({
                dateFormat: 'dd/mm/yy',
                firstDay: 1,
                dayNamesMin: this.contents.daysOfWeek,
                monthNames: this.contents.monthNames,
                prevText: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 12L6 8L10 4" stroke="#1D2329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                `,
                nextText: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 4L10 8L6 12" stroke="#1D2329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        `,
                showOtherMonths: this.showOtherMonths,
                beforeShowDay: function (date) {
                    var monthStr = moment(date).format('YYYY-MM')
                    var dateStr = moment(date).format('YYYY-MM-DD')
                    var available = !!(self.data.availableDates[monthStr] && self.data.availableDates[monthStr][dateStr])
                    return [available, ,]
                },
                onChangeMonthYear: function (year, month) {
                    self.data.currentCalendarYear = year
                    var monthStr = moment(new Date(year, month - 1)).format('YYYY-MM')
                    self.updateAvailableDates(monthStr).then(function () {
                        self.data.obj.datepicker('refresh')
                        self.removeDatePickerControlHoverElement()
                    })
                },
                onSelect: function () {
                    var date = self.data.obj.datepicker('getDate')
                    self.change(date)
                },
                ...options
            }),
                setTimeout(() => {
                    self.removeDatePickerControlHoverElement()
                }, 100)
        },
        change: function (value) {
            this.$emit('change', value)
        },
        updateAvailableDates: function (monthStr, nextMonth) {
            this.data.currentCalendarMonth = +monthStr.split('-')[1]
            var self = this
            return this.getAvailableDates(monthStr, nextMonth).then(function (result) {
                self.setAvailableDates(monthStr, result)
                return result
            })
        },
        removeDatePickerControlHoverElement() {
            // Remove the mousover popover
            $('.ui-datepicker-next').removeAttr('title')
            $('.ui-datepicker-prev').removeAttr('title')
            $('.ui-datepicker-trigger').removeAttr('title')
        },
        setAvailableDates: function (monthStr, dates) {
            var self = this
            // clear available dates by months
            dates
                .reduce(function (monthStrs, date) {
                    var monthStr = date.split('-')
                    monthStr.pop()
                    monthStr = monthStr.join('-')
                    if (!monthStrs.includes(monthStr)) {
                        monthStrs.push(monthStr)
                    }
                    return monthStrs
                }, [])
                .forEach(function (monthStr) {
                    self.$set(self.data.availableDates, monthStr, {})
                })
            // set available dates
            dates.forEach(function (date) {
                var monthStr = date.split('-')
                monthStr.pop()
                monthStr = monthStr.join('-')
                self.$set(self.data.availableDates[monthStr], date, true)
            })
        },
        setDefaultDate: function (dates) {
            var defaultDate = this.getDefaultDate(dates)
            if (!defaultDate) {
                return
            }

            this.data.obj.datepicker('destroy')
            this.init({
                defaultDate
            })
        },
        changeDateToNextWinter() {
            const date = new Date(getStartOfWinterDate())
            this.data.obj.datepicker('setDate', date)
        }
    },
    beforeDestroy: function () {
        this.data.obj.datepicker('destroy')
        this.removeDatePickerControlHoverElement()
    },
    async mounted() {
        var self = this
        this.data.obj = $(this.$refs.datepicker)
        this.init({})
        var monthStr = moment(this.month ? new Date(this.month.split('-')[0], this.month.split('-')[1] - 1) : new Date()).format('YYYY-MM')
        // var monthStr = getStartOfWinterDate()
        this.updateAvailableDates(monthStr, true).then(function (dates) {
            self.setDefaultDate(dates)
            if (self.value) {
                self.data.obj.datepicker('setDate', self.value)
            }
        })


    }
}
</script>
